import React from 'react';
import { FaSearch, FaCreditCard, FaGift, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './HowItWorks.css';

const steps = [
  {
    number: 1,
    icon: <FaSearch size={28} color="#C62828" />,
    title: 'Discover Great Deals',
    description:
      'Browse our wide selection of exclusive deals from top restaurants, retailers and more. Filter by category to find exactly what you\'re looking for.',
  },
  {
    number: 2,
    icon: <FaCreditCard size={28} color="#C62828" />,
    title: 'Easy Secure Payment',
    description:
      'Purchase your desired deals with our secure checkout process. We accept all major credit cards and digital payment methods.',
  },
  {
    number: 3,
    icon: <FaGift size={28} color="#C62828" />,
    title: 'Redeem & Enjoy',
    description:
      'Receive your digital voucher instantly. Present it at the venue to redeem your deal and enjoy significant savings on your purchase.',
  },
];

const HowItWorks = () => {
  const navigate = useNavigate();

  return (
    <section className="how-it-works-section">
      <button className="back-btn" onClick={() => navigate('/')}>
        <FaArrowLeft />
      </button>

      <div className="how-it-works-container">
        <h2 className="hiw-title">How It Works</h2>
        <p className="hiw-subtitle">
          Get started with DiscountDost in just a few simple steps. Discover, purchase, and redeem deals effortlessly.
        </p>
        <div className="hiw-steps">
          {steps.map((step, index) => (
            <div className="hiw-step-card" key={index}>
              <div className="hiw-step-number">{step.number}</div>
              <div className="hiw-icon">{step.icon}</div>
              <h3 className="hiw-step-title">{step.title}</h3>
              <p className="hiw-step-description">{step.description}</p>
            </div>
          ))}
        </div>
        <button className="hiw-start-btn">Get Started Now</button>
      </div>
    </section>
  );
};

export default HowItWorks;
